function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var InstallAppOverlayTemplate = require('./install-app.template.js');
var SaitoOverlay = require('./../../../../lib/saito/ui/saito-overlay/saito-overlay');
var AddAppOverlay = /*#__PURE__*/function () {
  function AddAppOverlay(app, mod) {
    _classCallCheck(this, AddAppOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.bin = '';
    this.description = '';
    this.image = '';
    this.module = '';
    this.publisher = '';
    this.request = '';
    this.name = '';
    this.version = '';
    this.categories = 'Utility';
    this.tx = null;
    this.tx_json = null;
    this.slug = null;
  }
  return _createClass(AddAppOverlay, [{
    key: "render",
    value: function render() {
      var _this$mod, _this$mod$attachStyle;
      // Install may open from Settings/RedSquare where /devtools is not the
      // active page — attach module CSS via the standard ModTemplate path.
      (_this$mod = this.mod) === null || _this$mod === void 0 || (_this$mod$attachStyle = _this$mod.attachStyleSheets) === null || _this$mod$attachStyle === void 0 || _this$mod$attachStyle.call(_this$mod);
      this.overlay.show(InstallAppOverlayTemplate(this.app, this.mod, this));
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      try {
        var this_self = this;
        var publisherHelp = document.querySelector('#saito-app-publisher-help');
        publisherHelp.onclick = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _context.n = 1;
                return salert("<p>Saito apps are fun, helpful and powerful. Be careful installing apps from publishers you don't know and trust.</p>" + "<p>We also recommend that you don't keep large amounts of Saito in your daily wallet, the same way you would not keep thousands of dollars in a real-life wallet.</p>");
              case 1:
                if (publisherHelp.isConnected) {
                  publisherHelp.focus();
                }
              case 2:
                return _context.a(2);
            }
          }, _callee);
        }));
        document.querySelector('#saito-app-install-btn').onclick = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
            var mod_data, c;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _context2.n = 1;
                  return this_self.app.storage.loadLocalApplications(this_self.slug);
                case 1:
                  mod_data = _context2.v;
                  console.log('mod_data:', mod_data);
                  console.log('mod_data length:', mod_data.length);

                  // check if dynamic application already installed
                  if (!(mod_data.length > 0)) {
                    _context2.n = 7;
                    break;
                  }
                  _context2.n = 2;
                  return sconfirm("Application '".concat(this_self.slug, "' already exist. Do you want to overwrite it?"));
                case 2:
                  c = _context2.v;
                  if (!c) {
                    _context2.n = 5;
                    break;
                  }
                  _context2.n = 3;
                  return this_self.app.storage.uninstallLocalApplication(this_self.slug);
                case 3:
                  _context2.n = 4;
                  return this_self.installApp();
                case 4:
                  _context2.n = 6;
                  break;
                case 5:
                  this_self.overlay.close();
                case 6:
                  _context2.n = 8;
                  break;
                case 7:
                  _context2.n = 8;
                  return this_self.installApp();
                case 8:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }();
      } catch (err) {
        console.error('Error: ', err);
        salert('An error occurred while installing application. Check console for details.');
      }
    }
  }, {
    key: "installApp",
    value: function () {
      var _installApp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var this_self;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this_self = this;
              _context3.n = 1;
              return this_self.app.storage.installLocalApplication(this_self.name.toLowerCase(), this_self.bin);
            case 1:
              salert('Applicaton saved. Reloading page...');
              this_self.overlay.close();
              reloadWindow(1500);
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function installApp() {
        return _installApp.apply(this, arguments);
      }
      return installApp;
    }()
  }]);
}();
module.exports = AddAppOverlay;